import CurrentLocaleContext from 'marketing-site/src/components/context/CurrentLocaleContext'
import { useContext } from 'react'

/**
 * Returns current locale code
 * @returns {string} code
 */
export default function useLocaleCode(): string {
  const { code } = useContext(CurrentLocaleContext)
  return code
}
